import { TemplateValidatorResponseItem } from "../data-model/templateValidatorModel";

/**
 * Returns true only when every result has overall_correctness.verdict === "ACCEPT".
 * If any result is "REJECT" or "REVIEW", returns false (validation modal should be shown).
 */
export function shouldProceedWithoutReview(
  results: TemplateValidatorResponseItem[],
): boolean {
  if (!results.length) return true;
  return results.every(
    (r) => r.parsed_content?.overall_correctness?.verdict === "ACCEPT",
  );
}
